// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"3bba7e82","457":"314e164c","842":"7220b0f5","851":"51126b85"}[chunkId] + ".chunk.js";
};